<template>
  <div class="deposit-app">
    <template v-if="showDepositForm">
      <p class="section-label">Please choose your provider</p>

      <!-- Provider: Airtel (solo si username empieza por 9) -->
      <label v-if="showAirtel" class="provider-card" :class="{ selected: selectedProvider === 'airtel' }">
        <input
          type="radio"
          name="provider"
          value="airtel"
          v-model="selectedProvider"
          class="radio-input"
        />
        <span class="radio-circle" :class="{ active: selectedProvider === 'airtel' }"></span>
        <img src="/icons/airtel.png" alt="Airtel" class="provider-logo" />
        <span class="provider-name">Airtel</span>
        <button type="button" class="info-btn" @click.prevent="onInfo('airtel')">
          <span class="info-icon">i</span>
        </button>
      </label>

      <!-- Provider: TNM (solo si username empieza por 8) -->
      <label v-if="showTnm" class="provider-card" :class="{ selected: selectedProvider === 'tnm' }">
        <input
          type="radio"
          name="provider"
          value="tnm"
          v-model="selectedProvider"
          class="radio-input"
        />
        <span class="radio-circle" :class="{ active: selectedProvider === 'tnm' }"></span>
        <img src="/icons/tnm.png" alt="TNM" class="provider-logo" />
        <span class="provider-name">TNM Mpamba</span>
        <button type="button" class="info-btn" @click.prevent="onInfo('tnm')">
          <span class="info-icon">i</span>
        </button>
      </label>

      <!-- Phone number row -->
      <div class="phone-row">
        <span class="phone-label">Your phone number:</span>
        <span class="phone-value">{{ formattedPhone }}</span>
      </div>

      <hr class="divider" />

      <!-- Amount section -->
      <p class="section-label amount-label">Deposit amount</p>
      <div class="amount-input-wrapper">
        <input
          type="number"
          v-model="amount"
          class="amount-input"
          placeholder="Deposit amount"
          min="50"
        />
        <span class="min-hint">Min 200 MWK</span>
      </div>

      <!-- Promo code (solo si está habilitado por config) -->
      <template v-if="showPromoCode">
        <div class="promo-header">
          <p class="section-label amount-label" style="margin:0">Promo code</p>
          <span class="optional-badge">OPTIONAL</span>
        </div>
        <div class="amount-input-wrapper">
          <input
            type="text"
            v-model="promoCode"
            class="amount-input"
            placeholder="Enter promo code"
            maxlength="50"
            :disabled="isLoading"
            @input="onPromoCodeInput"
            @blur="validatePromoCodeField"
          />
        </div>
        <div v-if="isValidatingPromo" class="promo-status loading">Validating promo code...</div>
        <div v-else-if="promoValidationMessage" class="promo-status" :class="promoValidationType">
          {{ promoValidationMessage }}
        </div>
        <div class="promo-attempts">
          Attempts left: {{ Math.max(0, maxPromoValidationAttempts - promoValidationAttempts) }}
        </div>
      </template>

      <!-- Deposit button -->
      <button
        type="button"
        class="deposit-btn"
        :disabled="isDepositButtonDisabled"
        @click="onDeposit"
      >
        <span v-if="isLoading" class="spinner"></span>
        <span v-else>Deposit</span>
      </button>

      <!-- Error message -->
      <p v-if="errorMessage" class="error-msg">{{ errorMessage }}</p>
    </template>

    <!-- Response box (Airtel / TNM) -->
    <div v-if="responseMessage" class="response-box" :class="responseType">
      <p>{{ responseMessage }}</p>
      <button class="deposit-btn retry-btn" @click="resetForm">
        {{ responseType === 'success' ? 'Accept' : 'Try again' }}
      </button>
    </div>

    <!-- Airtel Instructions Modal -->
    <transition name="modal-slide">
      <div v-if="showAirtelInstructions" class="instructions-overlay" @click.self="showAirtelInstructions = false">
        <div class="instructions-modal">
          <div class="instructions-header">
            <span class="instructions-title">AIRTEL MONEY INSTRUCTIONS</span>
            <button class="close-btn" @click="showAirtelInstructions = false">&times;</button>
          </div>
          <div class="instructions-steps">
            <div class="step-card">
              <div class="step-number">Step 1</div>
              <hr class="step-divider" />
              <p class="step-text"><!-- TODO: Airtel step 1 --></p>
            </div>
            <div class="step-card">
              <div class="step-number">Step 2</div>
              <hr class="step-divider" />
              <p class="step-text"><!-- TODO: Airtel step 2 --></p>
            </div>
            <div class="step-card">
              <div class="step-number">Step 3</div>
              <hr class="step-divider" />
              <p class="step-text"><!-- TODO: Airtel step 3 --></p>
            </div>
            <div class="step-card">
              <div class="step-number">Step 4</div>
              <hr class="step-divider" />
              <p class="step-text"><!-- TODO: Airtel step 4 --></p>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <!-- TNM Instructions Modal -->
    <transition name="modal-slide">
      <div v-if="showTnmInstructions" class="instructions-overlay" @click.self="showTnmInstructions = false">
        <div class="instructions-modal">
          <div class="instructions-header">
            <span class="instructions-title">TNM MPAMBA INSTRUCTIONS</span>
            <button class="close-btn" @click="showTnmInstructions = false">&times;</button>
          </div>
          <div class="instructions-steps">
            <div class="step-card">
              <div class="step-number">Step 1</div>
              <hr class="step-divider" />
              <p class="step-text"><!-- TODO: TNM step 1 --></p>
            </div>
            <div class="step-card">
              <div class="step-number">Step 2</div>
              <hr class="step-divider" />
              <p class="step-text"><!-- TODO: TNM step 2 --></p>
            </div>
            <div class="step-card">
              <div class="step-number">Step 3</div>
              <hr class="step-divider" />
              <p class="step-text"><!-- TODO: TNM step 3 --></p>
            </div>
            <div class="step-card">
              <div class="step-number">Step 4</div>
              <hr class="step-divider" />
              <p class="step-text"><!-- TODO: TNM step 4 --></p>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import common from '@/scripts/common.js';

export default {
  name: 'DepositAppMalawi',

  data() {
    return {
      selectedProvider: '',
      amount: null,
      promoCode: '',
      promoValidationMessage: '',
      promoValidationType: '',
      isValidatingPromo: false,
      isPromoValid: null,
      promoValidationAttempts: 0,
      maxPromoValidationAttempts: 3,
      showPromoCode: false,
      showDepositForm: true,
      showAirtelInstructions: false,
      showTnmInstructions: false,
      responseMessage: '',
      responseType: '',
      isLoading: false,
      errorMessage: '',
      username: this.$route.query.username || '',
      phone: this.$route.query.phone || '',
    };
  },

  computed: {
    formattedPhone() {
      const raw = this.phone.replace(/\D/g, '');
      if (!raw) return '—';
      return raw.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1 $2 $3 $4');
    },
    showAirtel() {
      return this.username.startsWith('9');
    },
    showTnm() {
      return this.username.startsWith('8');
    },
    hasPromoCodeInput() {
      return this.showPromoCode && (this.promoCode || '').trim().length > 0;
    },
    isDepositButtonDisabled() {
      if (this.isLoading || this.isValidatingPromo) return true;
      if (!this.selectedProvider || !this.amount) return true;
      if (this.hasPromoCodeInput) return this.isPromoValid !== true;
      return false;
    },
  },

  methods: {
    onInfo(provider) {
      if (provider === 'airtel') {
        this.showAirtelInstructions = true;
        return;
      }
      if (provider === 'tnm') {
        this.showTnmInstructions = true;
        return;
      }
    },

    onPromoCodeInput() {
      this.promoValidationMessage = '';
      this.promoValidationType = '';
      this.isPromoValid = null;
    },

    async validatePromoCodeField() {
      if (!this.showPromoCode) return true;
      const code = (this.promoCode || '').trim();
      if (!code) {
        this.promoValidationMessage = '';
        this.promoValidationType = '';
        this.isPromoValid = null;
        return true;
      }
      if (this.promoValidationAttempts >= this.maxPromoValidationAttempts && this.isPromoValid !== true) {
        this.promoValidationType = 'error';
        this.promoValidationMessage = 'You reached the maximum of 3 promo validation attempts.';
        return false;
      }
      try {
        this.isValidatingPromo = true;
        this.promoValidationMessage = '';
        this.promoValidationAttempts += 1;
        const apiUrl = process.env.VUE_APP_API_URL_GATEWAY;
        const response = await fetch(`${apiUrl}/wsb/system/validate-promo-code`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ division: 'DivisionMalawi', player_id: this.username, code }),
        });
        let result = {};
        try { result = await response.json(); } catch (_) { result = {}; }
        if (!response.ok) throw new Error(result.message || result.error || 'Invalid promo code.');
        const isValid =
          result.valid === true ||
          result.is_valid === true ||
          result.code === 0 ||
          result.code === '0' ||
          result.response_code === 'INS-0' ||
          result.data?.response_code === 'INS-0';
        if (!isValid) throw new Error(result.message || result.response_desc || result.data?.response_desc || 'Invalid promo code.');
        this.isPromoValid = true;
        this.promoValidationType = 'success';
        this.promoValidationMessage = result.message || result.response_desc || result.data?.response_desc || 'Promo code is valid.';
        return true;
      } catch (error) {
        this.isPromoValid = false;
        this.promoValidationType = 'error';
        this.promoValidationMessage = error.message || 'Invalid promo code.';
        return false;
      } finally {
        this.isValidatingPromo = false;
      }
    },

    async loadConfig() {
      const promoCodeEnabled = await common.checkConfigMW('promo_code_app');
      this.showPromoCode = promoCodeEnabled === true;
      if (!this.showPromoCode) this.promoCode = '';
    },

    async onDeposit() {
      this.errorMessage = '';
      if (!this.selectedProvider) {
        this.errorMessage = 'Please select a payment provider.';
        return;
      }
      if (!this.amount || Number(this.amount) < 200) {
        this.errorMessage = 'Minimum deposit amount is 200 MWK.';
        return;
      }
      if (this.showPromoCode && this.promoCode && this.isPromoValid !== true) {
        const valid = await this.validatePromoCodeField();
        if (!valid) return;
      }
      this.isLoading = true;
      if (this.selectedProvider === 'airtel') {
        await this.submitAirtel();
      } else if (this.selectedProvider === 'tnm') {
        await this.submitTnm();
      }
    },

    async submitAirtel() {
      const data = {
        depusername: this.username,
        amount: this.amount,
        promo_code: this.showPromoCode ? (this.promoCode.trim() || null) : null,
        origin: 'iframewebsite',
      };
      try {
        const apiUrl = process.env.VUE_APP_API_URL_AIRTEL;
        const response = await fetch(`${apiUrl}/api/deposite/airtel/request`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(data),
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || 'Unknown error occurred');
        if (result.code === 0) {
          this.responseMessage = result.data.description || 'Deposit request submitted successfully.';
          this.responseType = 'success';
        } else {
          this.responseMessage = 'Deposit failed: ' + result.description;
          this.responseType = 'error';
        }
        this.showDepositForm = false;
      } catch (error) {
        this.responseMessage = error.message || 'An unexpected error occurred.';
        this.responseType = 'error';
        this.showDepositForm = false;
      } finally {
        this.isLoading = false;
      }
    },

    async submitTnm() {
      const data = {
        username: this.username,
        amount: this.amount,
        promo_code: this.showPromoCode ? (this.promoCode.trim() || null) : null,
        origin: 'iframewebsite',
      };
      try {
        const apiUrl = process.env.VUE_APP_API_URL_TNM;
        const response = await fetch(`${apiUrl}/api/deposit/create`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(data),
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.message || 'Unknown error occurred');
        if (result.code === 0) {
          this.responseMessage = result.data.description || 'Deposit request submitted successfully.';
          this.responseType = result.data.status_code === 202 ? 'success' : 'error';
        } else {
          this.responseMessage = 'Deposit failed: ' + result.message;
          this.responseType = 'error';
        }
        this.showDepositForm = false;
      } catch (error) {
        this.responseMessage = error.message || 'An unexpected error occurred.';
        this.responseType = 'error';
        this.showDepositForm = false;
      } finally {
        this.isLoading = false;
      }
    },

    resetForm() {
      this.showDepositForm = true;
      this.responseMessage = '';
      this.responseType = '';
      this.amount = null;
      this.promoCode = '';
      this.isPromoValid = null;
      this.promoValidationMessage = '';
      this.promoValidationType = '';
      this.promoValidationAttempts = 0;
    },

    sendHeight() {
      const height = document.body.scrollHeight;
      window.parent.postMessage({ iframeHeight: height }, '*');
    },
  },

  async mounted() {
    await this.loadConfig();
    this.sendHeight();
    window.addEventListener('resize', this.sendHeight);
  },

  updated() {
    this.$nextTick(() => { this.sendHeight(); });
  },

  beforeUnmount() {
    window.removeEventListener('resize', this.sendHeight);
  },
};
</script>

<style scoped>
/* ──────────────────────────────────────────
   Root / Layout
────────────────────────────────────────── */
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700&display=swap');

.deposit-app {
  background-color: rgb(24, 34, 54);
  min-height: 100vh;
  padding: 16px 12px 24px;
  box-sizing: border-box;
  font-family: 'Poppins', sans-serif;
  color: #ffffff;
}

/* ──────────────────────────────────────────
   Section labels
────────────────────────────────────────── */
.section-label {
  font-size: 13px;
  font-weight: 500;
  margin: 0 0 8px 2px;
  color: #e0e6f0;
  text-align: left;
}

.amount-label {
  margin-top: 14px;
}

/* ──────────────────────────────────────────
   Provider cards
────────────────────────────────────────── */
.provider-card {
  display: flex;
  align-items: center;
  background-color: #172033;
  border: 1.5px solid #1f2e45;
  border-radius: 8px;
  padding: 9px 12px;
  margin-bottom: 8px;
  cursor: pointer;
  transition: border-color 0.2s;
  user-select: none;
}

.provider-card.selected {
  border-color: #3a6ea8;
}

.provider-card.card-disabled {
  opacity: 0.35;
  pointer-events: none;
  cursor: not-allowed;
}

/* hide native radio */
.radio-input {
  display: none;
}

/* custom radio circle */
.radio-circle {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 2px solid #5a7a9a;
  margin-right: 10px;
  flex-shrink: 0;
  position: relative;
  transition: border-color 0.2s;
}

.radio-circle.active {
  border-color: #4a9eff;
}

.radio-circle.active::after {
  content: '';
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #4a9eff;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

/* provider logo */
.provider-logo {
  width: 36px;
  height: 36px;
  object-fit: contain;
  border-radius: 5px;
  margin-right: 10px;
  flex-shrink: 0;
}

/* provider name */
.provider-name {
  flex: 1;
  font-size: 13px;
  font-weight: 500;
  text-align: right;
  color: #d0dce8;
}

/* info button */
.info-btn {
  background: transparent;
  border: 2px solid #5a7a9a;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-left: 10px;
  flex-shrink: 0;
  padding: 0;
  transition: border-color 0.2s;
}

.info-btn:hover {
  border-color: #8aaac8;
}

.info-icon {
  color: #8aaac8;
  font-size: 11px;
  font-style: italic;
  font-weight: 700;
  line-height: 1;
}

/* ──────────────────────────────────────────
   Phone number row
────────────────────────────────────────── */
.phone-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #111827;
  border-radius: 8px;
  padding: 11px 14px;
  margin-top: 4px;
}

.phone-label {
  font-size: 13px;
  color: #8a9db8;
}

.phone-value {
  font-size: 13px;
  font-weight: 600;
  color: #ffffff;
  letter-spacing: 0.5px;
}

/* ──────────────────────────────────────────
   Divider
────────────────────────────────────────── */
.divider {
  border: none;
  border-top: 1px solid #1f2e45;
  margin: 12px 0 0;
}

/* ──────────────────────────────────────────
   Amount input
────────────────────────────────────────── */
.amount-input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  background-color: #172033;
  border: 1.5px solid #1f2e45;
  border-radius: 8px;
  padding: 0 14px;
  height: 46px;
}

.amount-input {
  flex: 1;
  background: transparent;
  border: none;
  outline: none;
  color: #e0e6f0;
  font-size: 13px;
  padding: 0;
  min-width: 0;
}

.amount-input::placeholder {
  color: #4a6080;
}

/* remove native number arrows */
.amount-input::-webkit-outer-spin-button,
.amount-input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.amount-input[type='number'] {
  -moz-appearance: textfield;
}

.min-hint {
  font-size: 12px;
  color: #4a6080;
  white-space: nowrap;
  margin-left: 8px;
}

/* ──────────────────────────────────────────
   Deposit button
────────────────────────────────────────── */
.deposit-btn {
  width: 100%;
  margin-top: 18px;
  padding: 14px;
  background: linear-gradient(135deg, #ff4d7d, #e8305a);
  border: none;
  border-radius: 50px;
  color: #000000;
  font-size: 15px;
  font-weight: 700;
  letter-spacing: 0.5px;
  cursor: pointer;
  transition: opacity 0.2s, transform 0.1s;
}

.optional-hint {
  font-size: 11px;
  font-weight: 400;
  color: #4a6080;
}

.deposit-btn:hover:not(:disabled) {
  opacity: 0.9;
  transform: translateY(-1px);
}

.deposit-btn:active:not(:disabled) {
  transform: translateY(0);
}

.deposit-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

/* ──────────────────────────────────────────
   Spinner
────────────────────────────────────────── */
.spinner {
  display: inline-block;
  width: 18px;
  height: 18px;
  border: 2px solid rgba(255, 255, 255, 0.35);
  border-top-color: #ffffff;
  border-radius: 50%;
  animation: spin 0.7s linear infinite;
  vertical-align: middle;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

/* ──────────────────────────────────────────
   Error message
────────────────────────────────────────── */
.error-msg {
  margin-top: 14px;
  text-align: center;
  color: #ff6b8a;
  font-size: 13px;
}

/* ──────────────────────────────────────────
   Promo code
────────────────────────────────────────── */
.promo-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 14px;
  margin-bottom: 8px;
}

.optional-badge {
  background-color: #e8305a;
  color: #ffffff;
  font-size: 10px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 12px;
  letter-spacing: 0.5px;
  white-space: nowrap;
}

.promo-status {
  margin-top: 6px;
  font-size: 11px;
  padding: 0 2px;
}

.promo-status.success { color: #4ade80; }
.promo-status.error   { color: #ff6b8a; }
.promo-status.loading { color: #8aaac8; }

.promo-attempts {
  margin-top: 4px;
  font-size: 10px;
  color: #4a6080;
  padding: 0 2px;
}

/* ──────────────────────────────────────────
   Response box
────────────────────────────────────────── */
.response-box {
  border-radius: 10px;
  padding: 18px 16px;
  margin-top: 8px;
  text-align: center;
}

.response-box p {
  font-size: 14px;
  font-weight: 500;
  margin: 0 0 16px;
  color: #ffffff;
}

.response-box.success {
  background-color: rgba(74, 222, 128, 0.12);
  border: 1px solid #4ade80;
}

.response-box.error {
  background-color: rgba(255, 107, 138, 0.12);
  border: 1px solid #ff6b8a;
}

.retry-btn {
  margin-top: 0;
  padding: 10px 32px;
  width: auto;
  font-size: 13px;
}

/* ──────────────────────────────────────────
   Instructions Modal
────────────────────────────────────────── */
.instructions-overlay {
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 200;
  padding: 16px;
}

.instructions-modal {
  background-color: #172033;
  border-radius: 14px;
  padding: 20px 14px 24px;
  width: 100%;
  max-width: 420px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);
}

.instructions-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}

.instructions-title {
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 1.2px;
  color: #e0e6f0;
}

.close-btn {
  background: transparent;
  border: none;
  color: #8a9db8;
  font-size: 22px;
  cursor: pointer;
  padding: 0;
  line-height: 1;
  transition: color 0.2s;
}

.close-btn:hover {
  color: #ffffff;
}

.instructions-steps {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}

.step-card {
  background-color: #0f1b2d;
  border-radius: 8px;
  padding: 12px 10px;
  border-left: 3px solid #c9952a;
}

.step-number {
  font-size: 12px;
  font-weight: 600;
  color: #e0e6f0;
  margin-bottom: 8px;
}

.step-divider {
  border: none;
  border-top: 1px solid #1f2e45;
  margin: 0 0 10px;
}

.step-text {
  font-size: 11px;
  color: #8a9db8;
  line-height: 1.55;
  margin: 0;
  text-align: left;
}

.step-text strong {
  color: #d0dce8;
  font-weight: 600;
}

/* Modal animation */
.modal-slide-enter-active {
  transition: opacity 0.22s ease, transform 0.22s ease;
}
.modal-slide-leave-active {
  transition: opacity 0.18s ease, transform 0.18s ease;
}
.modal-slide-enter-from,
.modal-slide-leave-to {
  opacity: 0;
}
.modal-slide-enter-from .instructions-modal,
.modal-slide-leave-to .instructions-modal {
  transform: scale(0.95);
}
</style>
